<template>
  <div class="h5-order-summary">
    <div class="h5-order-summary-cell">
      <p class="h5-order-summary-cell__left">
        Total Items ({{ selectedSkuCount }})
      </p>
      <p v-if="selectedSkuCount > 0">
        <IntlCurrency
          :currency="targetCurrency"
          type="text"
        />{{ totalItemsPrice }}
      </p>
      <p v-else>
        --
      </p>
    </div>
    <div class="h5-order-summary-cell">
      <p class="h5-order-summary-cell__left">
        {{ hasProcessingSelected ? 'Est.Shipping' : 'Shipping Cost' }}
      </p>
      <div
        v-if="selectedSkuCount > 0"
        class="h5-order-summary-cell__right"
      >
        <span
          v-if="(Number(shippingCost) < Number(splitShippingCost)) && calculating === false"
          class="split-price"
        >
          <IntlCurrency
            :currency="targetCurrency"
            type="text"
          />{{ splitShippingCost }}
        </span>
        <IntlCurrency
          :currency="targetCurrency"
          type="text"
        />{{ shippingCost }}
      </div>
      <p v-else>
        --
      </p>
    </div>
    <div class="h5-order-summary-cell">
      <p class="h5-order-summary-cell__left">
        {{ hasProcessingSelected ? 'Est.Total' : 'Total' }}
      </p>
      <p v-if="selectedSkuCount > 0">
        <IntlCurrency
          :currency="targetCurrency"
          type="text"
        />{{ totalAmount }}
      </p>
      <p v-else>
        --
      </p>
    </div>
    <div class="h5-order-summary__divider" />
    <div class="h5-order-summary-cell h5-order-summary-rate">
      <p>Current exchange rate</p>
      <p>
        {{ targetCurrency }} {{ currency.current.targetUnit }}1
        =
        <IntlCurrency
          :currency="'USD'"
          type="text"
        />{{ currency.exchangeRate(targetCurrency, 'USD').toFixed(6) }}
      </p>
    </div>
    <div
      class="h5-order-summary-cell"
      v-if="discountAmountUSD"
    >
      <p class="h5-order-summary-cell__left h5-order-summary-cell__icon">
        <Icon
          name="coupon-l"
        />
        <span>Discount</span>
      </p>
      <p>
        -<IntlCurrency
          currency="USD"
          type="text"
        />{{ discountAmountUSD.toFixed(2) }}
      </p>
    </div>
    <div class="h5-order-summary-cell">
      <p class="h5-order-summary-cell__total">
        Total Amount
      </p>
      <p class="h5-order-summary-cell__amount">
        <IntlCurrency currency="USD" />{{ totalAmountAfterDiscount }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { IntlCurrency } from '@/components/NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import { useOrder } from '@/views/Carts/hooks/useOrder'
import { useCart } from '../hooks/useCart'

const currency = useCurrencyStore()

const targetCurrency = computed(() => currency.current.targetCurrency)

const { selectedSkuCount, hasProcessingSelected, discountAmountUSD, totalItemsPrice, shippingCost, splitShippingCost, totalAmount, totalAmountAfterDiscount } = useOrder()

const { calculating } = useCart()
</script>

<style lang="less" scoped>
.h5-order-summary {
  &__title {
    font-size: 14px;
    font-family: mon-700;
    line-height: 18px;
  }

  &__content {
    padding: 12px 0 0;
  }

  &-cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;

    + .h5-order-summary-cell {
      margin-top: 8px;
    }

    &__left {
      font-family: mon-500;
    }

    &__right {
      display: flex;
      align-items: center;
      .split-price {
        color: #b2b7c2;
        font-size: 11px;
        font-family: mon-600;
        text-decoration: line-through;
        margin-right: 4px;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 16px;

      > span {
        font-size: 12px;
      }
    }

    &__total {
      font-family: mon-700;
      font-size: 14px;
      line-height: 18px;
    }

    &__amount {
      font-family: mon-700;
      font-size: 16px;
      line-height: 20px;
      color: #052784;
    }
  }

  &-rate {
    font-family: mon-500;
    font-size: 11px;
    color: #6E717A;
  }

  &__divider {
    margin: 12px 0;
    height: 1px;
    background-color: #DFDFDF;
  }
}
</style>
